import { useTranslation } from 'react-i18next';

import { LocaleSwitcher } from '@/components/AppLayout/LocaleSwitcher';
import { LocationSwitcher } from '@/components/AppLayout/LocationSwitcher';

import { MenuSection, SidebarMenuProps } from '@/types';

type MobileSidebarHeaderProps = SidebarMenuProps & {
  activeSection?: MenuSection;
};

export const MobileSidebarHeader = (props: MobileSidebarHeaderProps) => {
  const {
    location_props,
    change_languages_url,
    activeSection,
    is_location_switcher_visible,
  } = props;
  const { t } = useTranslation();

  return (
    <div className="dark border-sidebar-border bg-sidebar text-foreground flex flex-col gap-2 border-b p-2 pb-4">
      {is_location_switcher_visible && <LocationSwitcher {...location_props} />}
      <LocaleSwitcher url={change_languages_url} />
      <span className="text-sidebar-menu-foreground mt-1 text-center text-sm font-semibold">
        {activeSection ? t(activeSection.label) : null}
      </span>
    </div>
  );
};
